import { AgentChatMessage } from './AgentChat.types';

/**
 * Ids of agent replies that close a turn — the last agent message before the
 * next user message (or the end of the thread). These are the replies worth
 * rating, so the thumbs row only appears on them.
 */
export const finalAgentReplyIds = (
  messages: AgentChatMessage[],
): Set<string> => {
  const ids = new Set<string>();
  const turns = messages.filter(
    (message) => message.role === 'user' || message.role === 'agent',
  );
  turns.forEach((message, index) => {
    if (message.role !== 'agent') return;
    const next = turns[index + 1];
    if (!next || next.role === 'user') ids.add(message.id);
  });
  return ids;
};
